<template lang="html">
  <div>
    <AutocompleteInput
      v-model="searchText"
      :idSuffix="idSuffix"
      :handleKeyDown="handleKeyDown"
      :prependIcon="icon"
      :appendIcon="appendIcon"
      :label="label"
      icon="mdi-flag"/>
    <AutocompleteSuggestions
      v-if="makeSuggestion"
      v-model="activeSuggestion"
      :idSuffix="idSuffix"
      :searchText="searchText"
      :getSuggestions="getSuggestions"
      :raiseError="raiseError"
      :onSuggestionSelection="onSuggestionSelection"
      :status="serviceStatus"
      :keyEvent="keyEvent"/>
  </div>
</template>

<script>
import AutocompleteInput from './AutocompleteInput';
import AutocompleteSuggestions from './AutocompleteSuggestions';
import injectScript from './inject-script';
import validator from './validator';
export default {
  components: {
    AutocompleteInput,
    AutocompleteSuggestions
  },
  props: {
    value: {
      required: true,
      validator: v => validator(v, { string: true, nil: true, undef: true })
    },
    label: {
      required: false,
      type: String
    },
    idSuffix: {
      required: true,
      type: [String, Number],
      default: `${Math.random() * 100}`
    },
    raiseError: {
      required: true,
      type: Function,
      default: (e) => alert(e)
    },
    icon: {
      required: false,
      validator: v => validator(v, { object: true, string: true }),
      default: () => ({ icon: 'mdi-flag', color: 'green' })
    },
  },
  data: () => ({
    autocomplete: null,
    serviceStatus: null,
    searchText: null,
    activeSuggestion: null,
    keyEvent: { },
    makeSuggestion: true
  }),
  created () {
    injectScript(process.env.VUE_APP_GOOGLE_API_KEY)
      .then(this.initializeService)
      .catch(this.raiseError)
  },
  computed: {
    appendIcon () {
      return {
        icon: this.makeSuggestion ? 'mdi-close-circle' : 'mdi-check',
        color: this.makeSuggestion ? 'red' : 'green'
      }
    }
  },
  methods: {
    initializeService () {
      const google = window.google
      if (!google) { throw new Error('Google script not loaded') }
      if (!google.maps) { throw new Error('Maps script not loaded') }
      if (!google.maps.places) { throw new Error('Places script not loaded') }
      this.autocomplete = new google.maps.places.AutocompleteService()
      this.serviceStatus = google.maps.places.PlacesServiceStatus.OK
    },
    getSuggestions (payload, callback) {
      return this.autocomplete.getPlacePredictions(payload, callback)
    },
    onSuggestionSelection (suggestion) {
      this.activeSuggestion = null
      this.searchText = suggestion.description
      this.makeSuggestion = false
      this.$emit('input', suggestion.description)
    },
    handleKeyDown (ev) {
      if (ev.key === 'Backspace') {
        this.makeSuggestion = true
        return
      }
      // ev.preventDefault()
      this.keyEvent = { ev, value: ev.key }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
